export const ATHOSColors = {
  aqua: {
    default: "#1FB5AD",
    default_2: "#1ca19b",
    dark: "#15827C",
    darker: "#0F4D4A",
  },
  gray: {
    darker_2: "#333333",
    darker: "#4D4D4D",
    dark: "#888888",
    dark_05: "#969696",
    default: "#A6A6A6",
    light: "#CACACA",
    light_2: "#e4e4e4",
    lighter: "#fafafa",
  },
  red: {
    darker_2: "#500101",
    darker: "#7A0000",
    dark: "#9E1C1C",
    default: "#DA2222",
    light: "#eb9c9c",
  },
  white: {
    eggshell: "#F3F3F3",
    eggshell_faded: "#f3f3f3be",
  },
  black: {
    coal: "#242424",
    coal_faded: "#2424249d",
  },
  background: "#ffffff",
};
